<div class="dialog-header py-8">
  <h2 class="dialog-title text-gray-900">
    {{ "APP.COURSE_MANAGE" | translate }}
    <!-- <app-keenicon
      name="arrow-left"
      class="fs-2 cursor-pointer"
      type="solid"
    ></app-keenicon> -->
    <!-- {{ "APP.CONFIRM_SHIFT_EXIT" | translate }} -->
  </h2>
  <button
    type="button"
    aria-label="Close"
    class="btn-close"
    (click)="onClose()"
  ></button>
</div>
<div class="dialog-content py-6 text-start text-gray-800" [formGroup]="form">
  @if (!isAssigned()) {
  <span class=""
    >{{ "APP.AVAILABLE_COURSE" | translate }} {{ data?.amount || 0 }}</span
  >
  <!-- Picking a child in the select is not the same as adding them: the
       "ยืนยัน" button below only lights up once they are on the list. That
       step used to be an unlabelled pale-sky "+" that read as disabled, so
       the obvious path — choose the child, press ยืนยัน — went nowhere.
       Same shape as the other field-plus-action pairs on the parent screens,
       and the button now says what it does. -->
  <div class="field-row mb-4 mt-2">
    <div class="field-row__field">
      <app-select
        formControlName="student_id"
        name="student_id"
        placeholder="APP.STUDENT"
        bindLabel="full_name"
        [labelMode]="LabelMode.NO_LABEL"
        [options]="students()"
        [isDisabled]="!data.amount"
        [error]="errors?.student_id"
        [required]="true"
        [errorMessage]="' '"
      ></app-select>
    </div>

    <button
      class="btn btn-primary d-flex align-items-center gap-2 flex-shrink-0"
      data-testid="assign-add-student"
      [disabled]="!data.amount || !form.value.student_id"
      (click)="addStudent(form.value.student_id)"
    >
      <app-keenicon name="plus-square" class="fs-3 svg svg-icon"></app-keenicon>
      {{ "APP.ADD_STUDENT" | translate }}
    </button>
  </div>
  } @if(isLoading()){
  <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>
  <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>
  <ng-container *ngTemplateOutlet="skeletonItem"></ng-container>

  }@else { @if(isAssigned()){
  <div class="fs-4 fw-semibold text-gray-800 mb-4">
    {{ "APP.NO_COURSE_ACTIVE" | translate }}
  </div>

  } @for (item of assignedStudents(); track $index) {
  <section class="d-flex justify-content-between align-items-center py-2">
    <div class="d-flex align-items-center">
      <div class="symbol symbol-35px symbol-circle me-4">
        @if (item?.image_url) {
        <img [attr.alt]="item?.full_name || '-'" class="object-fit-cover" [src]="fileUrl + item?.image_url" />
        } @else {
        <span class="symbol-label bg-light-primary text-primary">
          <app-keenicon name="user" class="fs-2 text-primary"></app-keenicon>
        </span>
        }
      </div>

      <div class="d-flex flex-column">
        <div class="fw-semibold">
          <span class="fs-5 text-gray-800 me-3">{{ item?.full_name }}</span>
        </div>

        <span class="text-muted fs-7">
          {{ "APP.STUDENT" | translate }}
        </span>
      </div>
    </div>
    <button
      class="btn btn-sm btn-icom btn-light-danger w-auto p-2"
      (click)="!isAssigned() ? deleteAssigned(item) : deleteSavedAssign(item)"
    >
      <div class="d-flex align-items-center">
        <app-keenicon [name]="'trash'" class="fs-3 svg svg-icon"></app-keenicon>
      </div>
    </button>
  </section>
  @if (assignedStudents().length > 1) {

  <div class="my-2"></div>
  } } @if(isAssigned() && !assignedStudents().length){
  {{ "TABLE.NO_DATA" | translate }} } }
</div>
<div class="dialog-footer flex-end gap-4">
  @if(isAssigned()){
  <button
    class="btn btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800 col-12 col-sm-auto"
    (click)="onClose()"
  >
    {{ "COMPONENT.CLOSE" | translate }}
  </button>
  }@else {
  <button
    class="btn btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800 col-12 col-sm-auto"
    (click)="onClose()"
  >
    {{ "COMPONENT.CANCEL" | translate }}
  </button>
  <button
    class="btn btn-primary btn-get-started px-10 col-12 col-sm-auto"
    [disabled]="!assignedStudents().length"
    (click)="submitAssign()"
  >
    {{ "COMPONENT.CONFIRM" | translate }}
  </button>
  }
</div>

<ng-template #skeletonItem>
  <a
    class="d-flex align-items-center py-2 rounded bg-state-light bg-state-opacity-50 mb-1 cursor-unset"
  >
    <div
      class="skeleton symbol symbol-35px w-35px h-35px symbol-circle me-5"
    ></div>

    <div class="d-flex flex-column gap-2">
      <div class="d-flex flex-row align-items-center fw-bold w-auto">
        <div class="skeleton h-15px w-125px fs-6 me-3"></div>
        <div class="skeleton fw-semibold h-10px w-60px px-2 py-2"></div>
      </div>
      <div class="skeleton h-10px w-80px"></div>
    </div>
  </a>
</ng-template>
